import * as React from "react";
export const EventsCount = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__events-count` },
    React.createElement("span", { className: `rj-ev-list__${props.componentPrefix}__count` }, props.count));
//# sourceMappingURL=EventsCount.js.map